module.exports = "<div class=bc-navbar-loading> <div class=bc-navbar-loading-inner></div> </div> ";